import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getTickets, createTicket, updateTicketById, deleteTicketById } from "../api";

const FilterTableTicket = () => {
  const [Tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchTickets = async () => {
    try {
      const response = await getTickets();
      setTickets(response.data);
      setFilteredTickets(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching tickets:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Tickets.filter((Ticket) =>
        Ticket.descripcion.toLowerCase().includes(filterText.toLowerCase()) ||
        Ticket.estado.toLowerCase().includes(filterText.toLowerCase()) ||
        Ticket.respuesta.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredTickets(filtered);
    } else {
      setFilteredTickets(Tickets);
    }
  }, [filterText, Tickets]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateTicketById(formData.id, { descripcion: formData.descripcion, estado: formData.estado, respuesta: formData.respuesta });
        alert("Ticket actualizado con éxito.");
      } else {
        await createTicket(formData);
        alert("Ticket registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "", estado: "", respuesta: "" });
      setIsEditing(false);
      fetchTickets();
    } catch (error) {
      console.error("Error procesando el ticket:", error);
    }
  };

  const handleEdit = (Ticket) => {
    setFormData(Ticket);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "", estado: "", respuesta: ""});
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de cerrar este ticket?")) {
      try {
        await deleteTicketById(id);
        alert("Ticket cerrado con éxito.");
        fetchTickets();
      } catch (error) {
        console.error("Error cerrando el ticket:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Ticket" : "Agregar Ticket"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
            rows={4}
            placeholder="Escribe la duda, mejora o error aquí..."
          />
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredTickets.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th>Respuesta</th>
              <th>Estado</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredTickets.map((Ticket) => (
              <tr key={Ticket.id}>
                <td>{Ticket.id}</td>
                <td className="td-limit">{Ticket.descripcion}</td>
                <td className="td-limit">{Ticket.respuesta}</td>
                <td>{Ticket.estado}</td>
                <td>
                  <button onClick={() => handleEdit(Ticket)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Ticket.id)} className="button-table-red">
                    Solucionado
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableTicket.propTypes = {
  ticket: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableTicket;
